module.exports = __webpack_public_path__ + "static/img/NBA2K20LOGO.022d6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/NBA2K20/NBA2K20LOGO.png
// module id = YkQo
// module chunks = 0